/* eslint-disable @typescript-eslint/member-ordering */
/**
 * This file was automatically generated by `bwcx-api-client`.
 * DO NOT MODIFY IT BY HAND.
 */

import { AllowedRequestMethod, IBwcxApiRequestAdaptorArgs, AbstractResponseParser } from 'bwcx-api-client';
import { configure as configureUrlcat } from 'urlcat-fork';
import { GetAuditLogsReqDTO, GetAuditLogsResDTO, GetAuditLogDetailReqDTO, GetAuditLogDetailResDTO, GetVersionHistoryReqDTO, GetVersionHistoryResDTO, GetVersionDetailReqDTO, GetVersionDetailResDTO, CompareVersionsReqDTO, CompareVersionsResDTO, RestoreVersionReqDTO, RestoreVersionResDTO, GetAuditStatsReqDTO, GetAuditStatsResDTO } from '../modules/audit/audit.dto';
import { RegisterAdminReqDTO, LoginAdminWithUserNameReqDTO, GetSessionResDTO, UpdateAdminAvatarReqDTO, GetAllAdminsListResDTO, UpdateAdminRoleReqDTO, ResetAdminPasswordReqDTO, DeleteAdminReqDTO } from '../modules/admin/admin.dto';
import { DemoGetReqDTO, DemoGetRespDTO } from '../modules/demo/demo.dto';
import { GetGlobalConfigResDTO, UpdateGlobalConfigReqDTO } from '../modules/global-config/global-config.dto';
import { GetHomeDataResDTO, GetHomeNewsResDTO } from '../modules/home/home.dto';
import { GetMediaListReqDTO, GetMediaListResDTO, UploadMediaReqDTO, MediaDetailResDTO, GetMediaByIdReqDTO, UpdateMediaReqDTO, DeleteMediaReqDTO, InitChunkUploadReqDTO, InitChunkUploadResDTO, UploadChunkReqDTO, UploadChunkResDTO, CompleteChunkUploadReqDTO, CompleteChunkUploadResDTO, GetChunkUploadProgressReqDTO, GetChunkUploadProgressResDTO } from '../modules/media/media.dto';
import { CreateNewsReqDTO, UpdateNewsReqDTO, DeleteNewsReqDTO, GetNewsReqDTO, GetNewsDetailResDTO, GetAllNewsReqDTO, GetAllNewsResDTO, GetPublishedNewsListReqDTO, GetPublishedNewsListResDTO, CreateNewsCategoryReqDTO, UpdateNewsCategoryReqDTO, DeleteNewsCategoryReqDTO, GetNewsCategoryReqDTO, GetNewsCategoryResDTO, GetAllNewsCategoriesResDTO, GetVisibleNewsCategoriesResDTO, SetNewsCategoryReqDTO, BatchSetNewsCategoryReqDTO, GetNewsByCategoryReqDTO, GetNewsByCategoryResDTO, GetCategoryPreviewReqDTO, GetCategoryPreviewResDTO, GetAllCategoriesPreviewResDTO } from '../modules/news/news.dto';
import { CreateProjectReqDTO, UpdateProjectReqDTO, DeleteProjectReqDTO, GetProjectReqDTO, GetProjectDetailResDTO, GetAllProjectsReqDTO, GetAllProjectsResDTO } from '../modules/project/project.dto';
import { GetOverviewStatsResDTO, GetDailyViewStatsReqDTO, GetDailyViewStatsResDTO, GetAllPageViewStatsResDTO, RecordPageViewReqDTO } from '../modules/stats/stats.dto';

const urlcat = configureUrlcat({ arrayFormat: 'repeat' });

export class ApiClient<T = undefined> {
  private readonly _r: (args: IBwcxApiRequestAdaptorArgs<T>) => Promise<any>;
  private readonly _rp: AbstractResponseParser;

  public constructor(
    requestAdapter: { request: (args: IBwcxApiRequestAdaptorArgs<T>) => Promise<any> },
    responseParser: AbstractResponseParser,
  ) {
    this._r = requestAdapter.request;
    this._rp = responseParser;
  }

  /**
   * 获取审计日志列表
   *
   * @param {GetAuditLogsReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetAuditLogsResDTO} The response data (RespDTO).
   */
  public async getAuditLogs(req: GetAuditLogsReqDTO, opts?: T): Promise<GetAuditLogsResDTO> {
    return this._r(this._rArgs.a(req, opts)).then((resp) => this._rp.pat(GetAuditLogsResDTO, resp));
  }

  /**
   * 获取单条审计日志详情
   *
   * @param {GetAuditLogDetailReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetAuditLogDetailResDTO} The response data (RespDTO).
   */
  public async getAuditLogDetail(req: GetAuditLogDetailReqDTO, opts?: T): Promise<GetAuditLogDetailResDTO> {
    return this._r(this._rArgs.b(req, opts)).then((resp) => this._rp.pat(GetAuditLogDetailResDTO, resp));
  }

  /**
   * 获取实体版本历史
   *
   * @param {GetVersionHistoryReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetVersionHistoryResDTO} The response data (RespDTO).
   */
  public async getVersionHistory(req: GetVersionHistoryReqDTO, opts?: T): Promise<GetVersionHistoryResDTO> {
    return this._r(this._rArgs.c(req, opts)).then((resp) => this._rp.pat(GetVersionHistoryResDTO, resp));
  }

  /**
   * 获取特定版本详情
   *
   * @param {GetVersionDetailReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetVersionDetailResDTO} The response data (RespDTO).
   */
  public async getVersionDetail(req: GetVersionDetailReqDTO, opts?: T): Promise<GetVersionDetailResDTO> {
    return this._r(this._rArgs.d(req, opts)).then((resp) => this._rp.pat(GetVersionDetailResDTO, resp));
  }

  /**
   * 比较两个版本
   *
   * @param {CompareVersionsReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {CompareVersionsResDTO} The response data (RespDTO).
   */
  public async compareVersions(req: CompareVersionsReqDTO, opts?: T): Promise<CompareVersionsResDTO> {
    return this._r(this._rArgs.e(req, opts)).then((resp) => this._rp.pat(CompareVersionsResDTO, resp));
  }

  /**
   * 恢复到指定版本
   *
   * @param {RestoreVersionReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {RestoreVersionResDTO} The response data (RespDTO).
   */
  public async restoreVersion(req: RestoreVersionReqDTO, opts?: T): Promise<RestoreVersionResDTO> {
    return this._r(this._rArgs.f(req, opts)).then((resp) => this._rp.pat(RestoreVersionResDTO, resp));
  }

  /**
   * 获取审计统计信息
   *
   * @param {GetAuditStatsReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetAuditStatsResDTO} The response data (RespDTO).
   */
  public async getAuditStats(req: GetAuditStatsReqDTO, opts?: T): Promise<GetAuditStatsResDTO> {
    return this._r(this._rArgs.g(req, opts)).then((resp) => this._rp.pat(GetAuditStatsResDTO, resp));
  }

  /**
   * 管理员注册
   *
   * @param {RegisterAdminReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async register(req: RegisterAdminReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.h(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 管理员登录
   *
   * @param {LoginAdminWithUserNameReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async login(req: LoginAdminWithUserNameReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.i(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 管理员登出
   *
   * @param {null} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async logout(req?: null, opts?: T): Promise<null> {
    return this._r(this._rArgs.j(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 获取管理员会话信息
   *
   * @param {null} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetSessionResDTO} The response data (RespDTO).
   */
  public async getSession(req?: null, opts?: T): Promise<GetSessionResDTO> {
    return this._r(this._rArgs.k(req, opts)).then((resp) => this._rp.pat(GetSessionResDTO, resp));
  }

  /**
   * 更新管理员头像
   *
   * @param {UpdateAdminAvatarReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async updateAdminAvatar(req: UpdateAdminAvatarReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.l(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 获取所有管理员
   *
   * @param {null} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetAllAdminsListResDTO} The response data (RespDTO).
   */
  public async getAllAdmins(req?: null, opts?: T): Promise<GetAllAdminsListResDTO> {
    return this._r(this._rArgs.m(req, opts)).then((resp) => this._rp.pat(GetAllAdminsListResDTO, resp));
  }

  /**
   * 更新管理员角色
   *
   * @param {UpdateAdminRoleReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async updateAdminRole(req: UpdateAdminRoleReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.n(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 重置管理员密码
   *
   * @param {ResetAdminPasswordReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async resetAdminPassword(req: ResetAdminPasswordReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.o(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 删除管理员
   *
   * @param {DeleteAdminReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async deleteAdmin(req: DeleteAdminReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.p(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 一个示例接口
   *
   * @param {DemoGetReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {DemoGetRespDTO} The response data (RespDTO).
   */
  public async demoGet(req: DemoGetReqDTO, opts?: T): Promise<DemoGetRespDTO> {
    return this._r(this._rArgs.q(req, opts)).then((resp) => this._rp.pat(DemoGetRespDTO, resp));
  }

  /**
   * 获取全局配置
   *
   * @param {null} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetGlobalConfigResDTO} The response data (RespDTO).
   */
  public async getGlobalConfig(req?: null, opts?: T): Promise<GetGlobalConfigResDTO> {
    return this._r(this._rArgs.r(req, opts)).then((resp) => this._rp.pat(GetGlobalConfigResDTO, resp));
  }

  /**
   * 更新全局配置
   *
   * @param {UpdateGlobalConfigReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async updateGlobalConfig(req: UpdateGlobalConfigReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.s(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 获取首页数据
   *
   * @param {null} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetHomeDataResDTO} The response data (RespDTO).
   */
  public async getHomeData(req?: null, opts?: T): Promise<GetHomeDataResDTO> {
    return this._r(this._rArgs.t(req, opts)).then((resp) => this._rp.pat(GetHomeDataResDTO, resp));
  }

  /**
   * 获取首页展示新闻
   *
   * @param {null} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetHomeNewsResDTO} The response data (RespDTO).
   */
  public async getHomeNews(req?: null, opts?: T): Promise<GetHomeNewsResDTO> {
    return this._r(this._rArgs.u(req, opts)).then((resp) => this._rp.pat(GetHomeNewsResDTO, resp));
  }

  /**
   * 获取媒体列表
   *
   * @param {GetMediaListReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetMediaListResDTO} The response data (RespDTO).
   */
  public async getMediaList(req: GetMediaListReqDTO, opts?: T): Promise<GetMediaListResDTO> {
    return this._r(this._rArgs.v(req, opts)).then((resp) => this._rp.pat(GetMediaListResDTO, resp));
  }

  /**
   * 上传媒体文件
   *
   * @param {UploadMediaReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {MediaDetailResDTO} The response data (RespDTO).
   */
  public async uploadMedia(req: UploadMediaReqDTO, opts?: T): Promise<MediaDetailResDTO> {
    return this._r(this._rArgs.w(req, opts)).then((resp) => this._rp.pat(MediaDetailResDTO, resp));
  }

  /**
   * 获取媒体详情
   *
   * @param {GetMediaByIdReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {MediaDetailResDTO} The response data (RespDTO).
   */
  public async getMediaById(req: GetMediaByIdReqDTO, opts?: T): Promise<MediaDetailResDTO> {
    return this._r(this._rArgs.x(req, opts)).then((resp) => this._rp.pat(MediaDetailResDTO, resp));
  }

  /**
   * 更新媒体信息
   *
   * @param {UpdateMediaReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async updateMedia(req: UpdateMediaReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.y(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 删除媒体文件
   *
   * @param {DeleteMediaReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async deleteMedia(req: DeleteMediaReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.z(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 初始化分片上传
   *
   * @param {InitChunkUploadReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {InitChunkUploadResDTO} The response data (RespDTO).
   */
  public async initChunkUpload(req: InitChunkUploadReqDTO, opts?: T): Promise<InitChunkUploadResDTO> {
    return this._r(this._rArgs.aa(req, opts)).then((resp) => this._rp.pat(InitChunkUploadResDTO, resp));
  }

  /**
   * 上传分片
   *
   * @param {UploadChunkReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {UploadChunkResDTO} The response data (RespDTO).
   */
  public async uploadChunk(req: UploadChunkReqDTO, opts?: T): Promise<UploadChunkResDTO> {
    return this._r(this._rArgs.ab(req, opts)).then((resp) => this._rp.pat(UploadChunkResDTO, resp));
  }

  /**
   * 完成分片上传
   *
   * @param {CompleteChunkUploadReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {CompleteChunkUploadResDTO} The response data (RespDTO).
   */
  public async completeChunkUpload(req: CompleteChunkUploadReqDTO, opts?: T): Promise<CompleteChunkUploadResDTO> {
    return this._r(this._rArgs.ac(req, opts)).then((resp) => this._rp.pat(CompleteChunkUploadResDTO, resp));
  }

  /**
   * 查询分片上传进度
   *
   * @param {GetChunkUploadProgressReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetChunkUploadProgressResDTO} The response data (RespDTO).
   */
  public async getChunkUploadProgress(req: GetChunkUploadProgressReqDTO, opts?: T): Promise<GetChunkUploadProgressResDTO> {
    return this._r(this._rArgs.ad(req, opts)).then((resp) => this._rp.pat(GetChunkUploadProgressResDTO, resp));
  }

  /**
   * 创建新闻
   *
   * @param {CreateNewsReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async createNews(req: CreateNewsReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.ae(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 更新新闻
   *
   * @param {UpdateNewsReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async updateNews(req: UpdateNewsReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.af(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 删除新闻
   *
   * @param {DeleteNewsReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async deleteNews(req: DeleteNewsReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.ag(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 获取新闻详情（管理员用）
   *
   * @param {GetNewsReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetNewsDetailResDTO} The response data (RespDTO).
   */
  public async getNews(req: GetNewsReqDTO, opts?: T): Promise<GetNewsDetailResDTO> {
    return this._r(this._rArgs.ah(req, opts)).then((resp) => this._rp.pat(GetNewsDetailResDTO, resp));
  }

  /**
   * 获取已发布新闻详情（普通用户用）
   *
   * @param {GetNewsReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetNewsDetailResDTO} The response data (RespDTO).
   */
  public async getPublishedNews(req: GetNewsReqDTO, opts?: T): Promise<GetNewsDetailResDTO> {
    return this._r(this._rArgs.ai(req, opts)).then((resp) => this._rp.pat(GetNewsDetailResDTO, resp));
  }

  /**
   * 增加新闻阅览数
   *
   * @param {GetNewsReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async incrementNewsViewCount(req: GetNewsReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.aj(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 获取所有新闻列表（管理员用）
   *
   * @param {GetAllNewsReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetAllNewsResDTO} The response data (RespDTO).
   */
  public async getAllNews(req: GetAllNewsReqDTO, opts?: T): Promise<GetAllNewsResDTO> {
    return this._r(this._rArgs.ak(req, opts)).then((resp) => this._rp.pat(GetAllNewsResDTO, resp));
  }

  /**
   * 分页获取已发布新闻列表
   *
   * @param {GetPublishedNewsListReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetPublishedNewsListResDTO} The response data (RespDTO).
   */
  public async getPublishedNewsList(req: GetPublishedNewsListReqDTO, opts?: T): Promise<GetPublishedNewsListResDTO> {
    return this._r(this._rArgs.al(req, opts)).then((resp) => this._rp.pat(GetPublishedNewsListResDTO, resp));
  }

  /**
   * 创建新闻栏目
   *
   * @param {CreateNewsCategoryReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async createCategory(req: CreateNewsCategoryReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.am(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 更新新闻栏目
   *
   * @param {UpdateNewsCategoryReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async updateCategory(req: UpdateNewsCategoryReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.an(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 删除新闻栏目
   *
   * @param {DeleteNewsCategoryReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async deleteCategory(req: DeleteNewsCategoryReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.ao(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 获取单个新闻栏目（管理员用）
   *
   * @param {GetNewsCategoryReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetNewsCategoryResDTO} The response data (RespDTO).
   */
  public async getCategory(req: GetNewsCategoryReqDTO, opts?: T): Promise<GetNewsCategoryResDTO> {
    return this._r(this._rArgs.ap(req, opts)).then((resp) => this._rp.pat(GetNewsCategoryResDTO, resp));
  }

  /**
   * 获取所有新闻栏目列表（管理员用）
   *
   * @param {null} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetAllNewsCategoriesResDTO} The response data (RespDTO).
   */
  public async getAllCategories(req?: null, opts?: T): Promise<GetAllNewsCategoriesResDTO> {
    return this._r(this._rArgs.aq(req, opts)).then((resp) => this._rp.pat(GetAllNewsCategoriesResDTO, resp));
  }

  /**
   * 获取可见新闻栏目列表（前台用）
   *
   * @param {null} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetVisibleNewsCategoriesResDTO} The response data (RespDTO).
   */
  public async getVisibleCategories(req?: null, opts?: T): Promise<GetVisibleNewsCategoriesResDTO> {
    return this._r(this._rArgs.ar(req, opts)).then((resp) => this._rp.pat(GetVisibleNewsCategoriesResDTO, resp));
  }

  /**
   * 设置新闻栏目
   *
   * @param {SetNewsCategoryReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async setNewsCategory(req: SetNewsCategoryReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.as(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 批量设置新闻栏目
   *
   * @param {BatchSetNewsCategoryReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async batchSetNewsCategory(req: BatchSetNewsCategoryReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.at(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 按栏目获取新闻列表
   *
   * @param {GetNewsByCategoryReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetNewsByCategoryResDTO} The response data (RespDTO).
   */
  public async getNewsByCategory(req: GetNewsByCategoryReqDTO, opts?: T): Promise<GetNewsByCategoryResDTO> {
    return this._r(this._rArgs.au(req, opts)).then((resp) => this._rp.pat(GetNewsByCategoryResDTO, resp));
  }

  /**
   * 获取栏目预览数据（前台大卡片用）
   *
   * @param {GetCategoryPreviewReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetCategoryPreviewResDTO} The response data (RespDTO).
   */
  public async getCategoryPreview(req: GetCategoryPreviewReqDTO, opts?: T): Promise<GetCategoryPreviewResDTO> {
    return this._r(this._rArgs.av(req, opts)).then((resp) => this._rp.pat(GetCategoryPreviewResDTO, resp));
  }

  /**
   * 获取所有栏目预览数据（首页用）
   *
   * @param {null} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetAllCategoriesPreviewResDTO} The response data (RespDTO).
   */
  public async getAllCategoriesPreview(req?: null, opts?: T): Promise<GetAllCategoriesPreviewResDTO> {
    return this._r(this._rArgs.aw(req, opts)).then((resp) => this._rp.pat(GetAllCategoriesPreviewResDTO, resp));
  }

  /**
   * 创建项目
   *
   * @param {CreateProjectReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async createProject(req: CreateProjectReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.ax(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 更新项目
   *
   * @param {UpdateProjectReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async updateProject(req: UpdateProjectReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.ay(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 删除项目
   *
   * @param {DeleteProjectReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async deleteProject(req: DeleteProjectReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.az(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  /**
   * 获取项目详情
   *
   * @param {GetProjectReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetProjectDetailResDTO} The response data (RespDTO).
   */
  public async getProject(req: GetProjectReqDTO, opts?: T): Promise<GetProjectDetailResDTO> {
    return this._r(this._rArgs.ba(req, opts)).then((resp) => this._rp.pat(GetProjectDetailResDTO, resp));
  }

  /**
   * 获取所有项目列表（管理员用）
   *
   * @param {GetAllProjectsReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetAllProjectsResDTO} The response data (RespDTO).
   */
  public async getAllProjects(req: GetAllProjectsReqDTO, opts?: T): Promise<GetAllProjectsResDTO> {
    return this._r(this._rArgs.bb(req, opts)).then((resp) => this._rp.pat(GetAllProjectsResDTO, resp));
  }

  /**
   * 获取概览统计数据
   *
   * @param {null} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetOverviewStatsResDTO} The response data (RespDTO).
   */
  public async getOverviewStats(req?: null, opts?: T): Promise<GetOverviewStatsResDTO> {
    return this._r(this._rArgs.bc(req, opts)).then((resp) => this._rp.pat(GetOverviewStatsResDTO, resp));
  }

  /**
   * 获取每日访问统计
   *
   * @param {GetDailyViewStatsReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetDailyViewStatsResDTO} The response data (RespDTO).
   */
  public async getDailyViewStats(req: GetDailyViewStatsReqDTO, opts?: T): Promise<GetDailyViewStatsResDTO> {
    return this._r(this._rArgs.bd(req, opts)).then((resp) => this._rp.pat(GetDailyViewStatsResDTO, resp));
  }

  /**
   * 获取所有页面访问统计
   *
   * @param {null} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {GetAllPageViewStatsResDTO} The response data (RespDTO).
   */
  public async getAllPageViewStats(req?: null, opts?: T): Promise<GetAllPageViewStatsResDTO> {
    return this._r(this._rArgs.be(req, opts)).then((resp) => this._rp.pat(GetAllPageViewStatsResDTO, resp));
  }

  /**
   * 记录页面访问
   *
   * @param {RecordPageViewReqDTO} req The request data (compatible with ReqDTO).
   * @param {T} opts Extra request options.
   * @returns {null} The response data (RespDTO).
   */
  public async recordPageView(req: RecordPageViewReqDTO, opts?: T): Promise<null> {
    return this._r(this._rArgs.bf(req, opts)).then((resp) => this._rp.pat(null, resp));
  }

  private _rArgs = {
    a: (req: GetAuditLogsReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getAuditLogs', {
          param: {},
          query: {},
        }),
        data: {
          page: req.page,
          pageSize: req.pageSize,
          actionType: req.actionType,
          entityType: req.entityType,
          entityId: req.entityId,
          adminId: req.adminId,
          startDate: req.startDate,
          endDate: req.endDate,
          keyword: req.keyword,
        },
        extraOpts: opts,
        metadata: {
          name: 'getAuditLogs',
          method: 'POST',
          path: '/api/getAuditLogs',
          req: GetAuditLogsReqDTO,
          resp: GetAuditLogsResDTO,
        },
      };
    },
    b: (req: GetAuditLogDetailReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getAuditLogDetail', {
          param: {},
          query: {},
        }),
        data: {
          id: req.id,
        },
        extraOpts: opts,
        metadata: {
          name: 'getAuditLogDetail',
          method: 'POST',
          path: '/api/getAuditLogDetail',
          req: GetAuditLogDetailReqDTO,
          resp: GetAuditLogDetailResDTO,
        },
      };
    },
    c: (req: GetVersionHistoryReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getVersionHistory', {
          param: {},
          query: {},
        }),
        data: {
          entityType: req.entityType,
          entityId: req.entityId,
          page: req.page,
          pageSize: req.pageSize,
        },
        extraOpts: opts,
        metadata: {
          name: 'getVersionHistory',
          method: 'POST',
          path: '/api/getVersionHistory',
          req: GetVersionHistoryReqDTO,
          resp: GetVersionHistoryResDTO,
        },
      };
    },
    d: (req: GetVersionDetailReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getVersionDetail', {
          param: {},
          query: {},
        }),
        data: {
          id: req.id,
        },
        extraOpts: opts,
        metadata: {
          name: 'getVersionDetail',
          method: 'POST',
          path: '/api/getVersionDetail',
          req: GetVersionDetailReqDTO,
          resp: GetVersionDetailResDTO,
        },
      };
    },
    e: (req: CompareVersionsReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/compareVersions', {
          param: {},
          query: {},
        }),
        data: {
          versionId1: req.versionId1,
          versionId2: req.versionId2,
        },
        extraOpts: opts,
        metadata: {
          name: 'compareVersions',
          method: 'POST',
          path: '/api/compareVersions',
          req: CompareVersionsReqDTO,
          resp: CompareVersionsResDTO,
        },
      };
    },
    f: (req: RestoreVersionReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/restoreVersion', {
          param: {},
          query: {},
        }),
        data: {
          versionId: req.versionId,
        },
        extraOpts: opts,
        metadata: {
          name: 'restoreVersion',
          method: 'POST',
          path: '/api/restoreVersion',
          req: RestoreVersionReqDTO,
          resp: RestoreVersionResDTO,
        },
      };
    },
    g: (req: GetAuditStatsReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getAuditStats', {
          param: {},
          query: {},
        }),
        data: {
          startDate: req.startDate,
          endDate: req.endDate,
        },
        extraOpts: opts,
        metadata: {
          name: 'getAuditStats',
          method: 'POST',
          path: '/api/getAuditStats',
          req: GetAuditStatsReqDTO,
          resp: GetAuditStatsResDTO,
        },
      };
    },
    h: (req: RegisterAdminReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/register', {
          param: {},
          query: {},
        }),
        data: {
          username: req.username,
          password: req.password,
        },
        extraOpts: opts,
        metadata: {
          name: 'register',
          method: 'POST',
          path: '/api/register',
          req: RegisterAdminReqDTO,
          resp: null as null,
        },
      };
    },
    i: (req: LoginAdminWithUserNameReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/login', {
          param: {},
          query: {},
        }),
        data: {
          username: req.username,
          password: req.password,
        },
        extraOpts: opts,
        metadata: {
          name: 'login',
          method: 'POST',
          path: '/api/login',
          req: LoginAdminWithUserNameReqDTO,
          resp: null as null,
        },
      };
    },
    j: (req: null, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/logout', {
          param: {},
          query: {},
        }),
        data: {},
        extraOpts: opts,
        metadata: {
          name: 'logout',
          method: 'POST',
          path: '/api/logout',
          req: null as null,
          resp: null as null,
        },
      };
    },
    k: (req: null, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getSession', {
          param: {},
          query: {},
        }),
        data: {},
        extraOpts: opts,
        metadata: {
          name: 'getSession',
          method: 'POST',
          path: '/api/getSession',
          req: null as null,
          resp: GetSessionResDTO,
        },
      };
    },
    l: (req: UpdateAdminAvatarReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/updateAdminAvatar', {
          param: {},
          query: {},
        }),
        data: {
          avatar: req.avatar,
        },
        extraOpts: opts,
        metadata: {
          name: 'updateAdminAvatar',
          method: 'POST',
          path: '/api/updateAdminAvatar',
          req: UpdateAdminAvatarReqDTO,
          resp: null as null,
        },
      };
    },
    m: (req: null, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getAllAdmins', {
          param: {},
          query: {},
        }),
        data: {},
        extraOpts: opts,
        metadata: {
          name: 'getAllAdmins',
          method: 'POST',
          path: '/api/getAllAdmins',
          req: null as null,
          resp: GetAllAdminsListResDTO,
        },
      };
    },
    n: (req: UpdateAdminRoleReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/updateAdminRole', {
          param: {},
          query: {},
        }),
        data: {
          adminId: req.adminId,
          role: req.role,
        },
        extraOpts: opts,
        metadata: {
          name: 'updateAdminRole',
          method: 'POST',
          path: '/api/updateAdminRole',
          req: UpdateAdminRoleReqDTO,
          resp: null as null,
        },
      };
    },
    o: (req: ResetAdminPasswordReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/resetAdminPassword', {
          param: {},
          query: {},
        }),
        data: {
          adminId: req.adminId,
          newPassword: req.newPassword,
        },
        extraOpts: opts,
        metadata: {
          name: 'resetAdminPassword',
          method: 'POST',
          path: '/api/resetAdminPassword',
          req: ResetAdminPasswordReqDTO,
          resp: null as null,
        },
      };
    },
    p: (req: DeleteAdminReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/deleteAdmin', {
          param: {},
          query: {},
        }),
        data: {
          adminId: req.adminId,
        },
        extraOpts: opts,
        metadata: {
          name: 'deleteAdmin',
          method: 'POST',
          path: '/api/deleteAdmin',
          req: DeleteAdminReqDTO,
          resp: null as null,
        },
      };
    },
    q: (req: DemoGetReqDTO, opts?: any) => {
      return {
        method: 'GET' as AllowedRequestMethod,
        url: this._uf('/api/demoGet/:id', {
          param: {
            id: req.id,
          },
          query: {
            page: req.page,
          },
        }),
        data: {},
        extraOpts: opts,
        metadata: {
          name: 'demoGet',
          method: 'GET',
          path: '/api/demoGet/:id',
          req: DemoGetReqDTO,
          resp: DemoGetRespDTO,
        },
      };
    },
    r: (req: null, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getGlobalConfig', {
          param: {},
          query: {},
        }),
        data: {},
        extraOpts: opts,
        metadata: {
          name: 'getGlobalConfig',
          method: 'POST',
          path: '/api/getGlobalConfig',
          req: null as null,
          resp: GetGlobalConfigResDTO,
        },
      };
    },
    s: (req: UpdateGlobalConfigReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/updateGlobalConfig', {
          param: {},
          query: {},
        }),
        data: {
          title: req.title,
          slogan: req.slogan,
          description: req.description,
          logoPath: req.logoPath,
          homeNewsPreviewIds: req.homeNewsPreviewIds,
          homeProjectsPreviewIds: req.homeProjectsPreviewIds,
        },
        extraOpts: opts,
        metadata: {
          name: 'updateGlobalConfig',
          method: 'POST',
          path: '/api/updateGlobalConfig',
          req: UpdateGlobalConfigReqDTO,
          resp: null as null,
        },
      };
    },
    t: (req: null, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getHomeData', {
          param: {},
          query: {},
        }),
        data: {},
        extraOpts: opts,
        metadata: {
          name: 'getHomeData',
          method: 'POST',
          path: '/api/getHomeData',
          req: null as null,
          resp: GetHomeDataResDTO,
        },
      };
    },
    u: (req: null, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getHomeNews', {
          param: {},
          query: {},
        }),
        data: {},
        extraOpts: opts,
        metadata: {
          name: 'getHomeNews',
          method: 'POST',
          path: '/api/getHomeNews',
          req: null as null,
          resp: GetHomeNewsResDTO,
        },
      };
    },
    v: (req: GetMediaListReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getMediaList', {
          param: {},
          query: {},
        }),
        data: {
          type: req.type,
          page: req.page,
          pageSize: req.pageSize,
        },
        extraOpts: opts,
        metadata: {
          name: 'getMediaList',
          method: 'POST',
          path: '/api/getMediaList',
          req: GetMediaListReqDTO,
          resp: GetMediaListResDTO,
        },
      };
    },
    w: (req: UploadMediaReqDTO, opts?: any) => {
      const formData = new FormData();
      formData.append('file', req.file);
      formData.append('type', req.type);
      formData.append('alt', req.alt);
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/uploadMedia', {
          param: {},
          query: {},
        }),
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        extraOpts: opts,
        metadata: {
          name: 'uploadMedia',
          method: 'POST',
          path: '/api/uploadMedia',
          req: UploadMediaReqDTO,
          resp: MediaDetailResDTO,
        },
      };
    },
    x: (req: GetMediaByIdReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getMediaById', {
          param: {},
          query: {},
        }),
        data: {
          id: req.id,
        },
        extraOpts: opts,
        metadata: {
          name: 'getMediaById',
          method: 'POST',
          path: '/api/getMediaById',
          req: GetMediaByIdReqDTO,
          resp: MediaDetailResDTO,
        },
      };
    },
    y: (req: UpdateMediaReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/updateMedia', {
          param: {},
          query: {},
        }),
        data: {
          id: req.id,
          alt: req.alt,
        },
        extraOpts: opts,
        metadata: {
          name: 'updateMedia',
          method: 'POST',
          path: '/api/updateMedia',
          req: UpdateMediaReqDTO,
          resp: null as null,
        },
      };
    },
    z: (req: DeleteMediaReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/deleteMedia', {
          param: {},
          query: {},
        }),
        data: {
          id: req.id,
        },
        extraOpts: opts,
        metadata: {
          name: 'deleteMedia',
          method: 'POST',
          path: '/api/deleteMedia',
          req: DeleteMediaReqDTO,
          resp: null as null,
        },
      };
    },
    aa: (req: InitChunkUploadReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/initChunkUpload', {
          param: {},
          query: {},
        }),
        data: {
          filename: req.filename,
          fileSize: req.fileSize,
          type: req.type,
          alt: req.alt,
          totalChunks: req.totalChunks,
        },
        extraOpts: opts,
        metadata: {
          name: 'initChunkUpload',
          method: 'POST',
          path: '/api/initChunkUpload',
          req: InitChunkUploadReqDTO,
          resp: InitChunkUploadResDTO,
        },
      };
    },
    ab: (req: UploadChunkReqDTO, opts?: any) => {
      const formData = new FormData();
      formData.append('uploadId', req.uploadId);
      formData.append('chunkIndex', req.chunkIndex);
      formData.append('chunk', req.chunk);
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/uploadChunk', {
          param: {},
          query: {},
        }),
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        extraOpts: opts,
        metadata: {
          name: 'uploadChunk',
          method: 'POST',
          path: '/api/uploadChunk',
          req: UploadChunkReqDTO,
          resp: UploadChunkResDTO,
        },
      };
    },
    ac: (req: CompleteChunkUploadReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/completeChunkUpload', {
          param: {},
          query: {},
        }),
        data: {
          uploadId: req.uploadId,
        },
        extraOpts: opts,
        metadata: {
          name: 'completeChunkUpload',
          method: 'POST',
          path: '/api/completeChunkUpload',
          req: CompleteChunkUploadReqDTO,
          resp: CompleteChunkUploadResDTO,
        },
      };
    },
    ad: (req: GetChunkUploadProgressReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getChunkUploadProgress', {
          param: {},
          query: {},
        }),
        data: {
          uploadId: req.uploadId,
        },
        extraOpts: opts,
        metadata: {
          name: 'getChunkUploadProgress',
          method: 'POST',
          path: '/api/getChunkUploadProgress',
          req: GetChunkUploadProgressReqDTO,
          resp: GetChunkUploadProgressResDTO,
        },
      };
    },
    ae: (req: CreateNewsReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/createNews', {
          param: {},
          query: {},
        }),
        data: {
          title: req.title,
          summary: req.summary,
          content: req.content,
          coverImage: req.coverImage,
          isPublished: req.isPublished,
          categoryId: req.categoryId,
          publishedAt: req.publishedAt,
          wxOfficialLink: req.wxOfficialLink,
        },
        extraOpts: opts,
        metadata: {
          name: 'createNews',
          method: 'POST',
          path: '/api/createNews',
          req: CreateNewsReqDTO,
          resp: null as null,
        },
      };
    },
    af: (req: UpdateNewsReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/updateNews', {
          param: {},
          query: {},
        }),
        data: {
          id: req.id,
          title: req.title,
          summary: req.summary,
          content: req.content,
          coverImage: req.coverImage,
          isPublished: req.isPublished,
          categoryId: req.categoryId,
          publishedAt: req.publishedAt,
          wxOfficialLink: req.wxOfficialLink,
        },
        extraOpts: opts,
        metadata: {
          name: 'updateNews',
          method: 'POST',
          path: '/api/updateNews',
          req: UpdateNewsReqDTO,
          resp: null as null,
        },
      };
    },
    ag: (req: DeleteNewsReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/deleteNews', {
          param: {},
          query: {},
        }),
        data: {
          id: req.id,
        },
        extraOpts: opts,
        metadata: {
          name: 'deleteNews',
          method: 'POST',
          path: '/api/deleteNews',
          req: DeleteNewsReqDTO,
          resp: null as null,
        },
      };
    },
    ah: (req: GetNewsReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getNews', {
          param: {},
          query: {},
        }),
        data: {
          id: req.id,
        },
        extraOpts: opts,
        metadata: {
          name: 'getNews',
          method: 'POST',
          path: '/api/getNews',
          req: GetNewsReqDTO,
          resp: GetNewsDetailResDTO,
        },
      };
    },
    ai: (req: GetNewsReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getPublishedNews', {
          param: {},
          query: {},
        }),
        data: {
          id: req.id,
        },
        extraOpts: opts,
        metadata: {
          name: 'getPublishedNews',
          method: 'POST',
          path: '/api/getPublishedNews',
          req: GetNewsReqDTO,
          resp: GetNewsDetailResDTO,
        },
      };
    },
    aj: (req: GetNewsReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/incrementNewsViewCount', {
          param: {},
          query: {},
        }),
        data: {
          id: req.id,
        },
        extraOpts: opts,
        metadata: {
          name: 'incrementNewsViewCount',
          method: 'POST',
          path: '/api/incrementNewsViewCount',
          req: GetNewsReqDTO,
          resp: null as null,
        },
      };
    },
    ak: (req: GetAllNewsReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getAllNews', {
          param: {},
          query: {},
        }),
        data: {
          page: req.page,
          pageSize: req.pageSize,
        },
        extraOpts: opts,
        metadata: {
          name: 'getAllNews',
          method: 'POST',
          path: '/api/getAllNews',
          req: GetAllNewsReqDTO,
          resp: GetAllNewsResDTO,
        },
      };
    },
    al: (req: GetPublishedNewsListReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getPublishedNewsList', {
          param: {},
          query: {},
        }),
        data: {
          page: req.page,
          pageSize: req.pageSize,
        },
        extraOpts: opts,
        metadata: {
          name: 'getPublishedNewsList',
          method: 'POST',
          path: '/api/getPublishedNewsList',
          req: GetPublishedNewsListReqDTO,
          resp: GetPublishedNewsListResDTO,
        },
      };
    },
    am: (req: CreateNewsCategoryReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/createCategory', {
          param: {},
          query: {},
        }),
        data: {
          name: req.name,
          description: req.description,
          coverImage: req.coverImage,
          order: req.order,
          isVisible: req.isVisible,
        },
        extraOpts: opts,
        metadata: {
          name: 'createCategory',
          method: 'POST',
          path: '/api/createCategory',
          req: CreateNewsCategoryReqDTO,
          resp: null as null,
        },
      };
    },
    an: (req: UpdateNewsCategoryReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/updateCategory', {
          param: {},
          query: {},
        }),
        data: {
          id: req.id,
          name: req.name,
          description: req.description,
          coverImage: req.coverImage,
          order: req.order,
          isVisible: req.isVisible,
        },
        extraOpts: opts,
        metadata: {
          name: 'updateCategory',
          method: 'POST',
          path: '/api/updateCategory',
          req: UpdateNewsCategoryReqDTO,
          resp: null as null,
        },
      };
    },
    ao: (req: DeleteNewsCategoryReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/deleteCategory', {
          param: {},
          query: {},
        }),
        data: {
          id: req.id,
        },
        extraOpts: opts,
        metadata: {
          name: 'deleteCategory',
          method: 'POST',
          path: '/api/deleteCategory',
          req: DeleteNewsCategoryReqDTO,
          resp: null as null,
        },
      };
    },
    ap: (req: GetNewsCategoryReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getCategory', {
          param: {},
          query: {},
        }),
        data: {
          id: req.id,
        },
        extraOpts: opts,
        metadata: {
          name: 'getCategory',
          method: 'POST',
          path: '/api/getCategory',
          req: GetNewsCategoryReqDTO,
          resp: GetNewsCategoryResDTO,
        },
      };
    },
    aq: (req: null, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getAllCategories', {
          param: {},
          query: {},
        }),
        data: {},
        extraOpts: opts,
        metadata: {
          name: 'getAllCategories',
          method: 'POST',
          path: '/api/getAllCategories',
          req: null as null,
          resp: GetAllNewsCategoriesResDTO,
        },
      };
    },
    ar: (req: null, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getVisibleCategories', {
          param: {},
          query: {},
        }),
        data: {},
        extraOpts: opts,
        metadata: {
          name: 'getVisibleCategories',
          method: 'POST',
          path: '/api/getVisibleCategories',
          req: null as null,
          resp: GetVisibleNewsCategoriesResDTO,
        },
      };
    },
    as: (req: SetNewsCategoryReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/setNewsCategory', {
          param: {},
          query: {},
        }),
        data: {
          newsId: req.newsId,
          categoryId: req.categoryId,
        },
        extraOpts: opts,
        metadata: {
          name: 'setNewsCategory',
          method: 'POST',
          path: '/api/setNewsCategory',
          req: SetNewsCategoryReqDTO,
          resp: null as null,
        },
      };
    },
    at: (req: BatchSetNewsCategoryReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/batchSetNewsCategory', {
          param: {},
          query: {},
        }),
        data: {
          newsIds: req.newsIds,
          categoryId: req.categoryId,
        },
        extraOpts: opts,
        metadata: {
          name: 'batchSetNewsCategory',
          method: 'POST',
          path: '/api/batchSetNewsCategory',
          req: BatchSetNewsCategoryReqDTO,
          resp: null as null,
        },
      };
    },
    au: (req: GetNewsByCategoryReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getNewsByCategory', {
          param: {},
          query: {},
        }),
        data: {
          categoryId: req.categoryId,
          page: req.page,
          pageSize: req.pageSize,
        },
        extraOpts: opts,
        metadata: {
          name: 'getNewsByCategory',
          method: 'POST',
          path: '/api/getNewsByCategory',
          req: GetNewsByCategoryReqDTO,
          resp: GetNewsByCategoryResDTO,
        },
      };
    },
    av: (req: GetCategoryPreviewReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getCategoryPreview', {
          param: {},
          query: {},
        }),
        data: {
          categoryId: req.categoryId,
          cardNewsCount: req.cardNewsCount,
          listNewsCount: req.listNewsCount,
        },
        extraOpts: opts,
        metadata: {
          name: 'getCategoryPreview',
          method: 'POST',
          path: '/api/getCategoryPreview',
          req: GetCategoryPreviewReqDTO,
          resp: GetCategoryPreviewResDTO,
        },
      };
    },
    aw: (req: null, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getAllCategoriesPreview', {
          param: {},
          query: {},
        }),
        data: {},
        extraOpts: opts,
        metadata: {
          name: 'getAllCategoriesPreview',
          method: 'POST',
          path: '/api/getAllCategoriesPreview',
          req: null as null,
          resp: GetAllCategoriesPreviewResDTO,
        },
      };
    },
    ax: (req: CreateProjectReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/createProject', {
          param: {},
          query: {},
        }),
        data: {
          name: req.name,
          description: req.description,
          repoUrl: req.repoUrl,
          websiteUrl: req.websiteUrl,
          coverImage: req.coverImage,
          bgColor: req.bgColor,
          isFeatured: req.isFeatured,
        },
        extraOpts: opts,
        metadata: {
          name: 'createProject',
          method: 'POST',
          path: '/api/createProject',
          req: CreateProjectReqDTO,
          resp: null as null,
        },
      };
    },
    ay: (req: UpdateProjectReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/updateProject', {
          param: {},
          query: {},
        }),
        data: {
          id: req.id,
          name: req.name,
          description: req.description,
          repoUrl: req.repoUrl,
          websiteUrl: req.websiteUrl,
          coverImage: req.coverImage,
          bgColor: req.bgColor,
          isFeatured: req.isFeatured,
        },
        extraOpts: opts,
        metadata: {
          name: 'updateProject',
          method: 'POST',
          path: '/api/updateProject',
          req: UpdateProjectReqDTO,
          resp: null as null,
        },
      };
    },
    az: (req: DeleteProjectReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/deleteProject', {
          param: {},
          query: {},
        }),
        data: {
          id: req.id,
        },
        extraOpts: opts,
        metadata: {
          name: 'deleteProject',
          method: 'POST',
          path: '/api/deleteProject',
          req: DeleteProjectReqDTO,
          resp: null as null,
        },
      };
    },
    ba: (req: GetProjectReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getProject', {
          param: {},
          query: {},
        }),
        data: {
          id: req.id,
        },
        extraOpts: opts,
        metadata: {
          name: 'getProject',
          method: 'POST',
          path: '/api/getProject',
          req: GetProjectReqDTO,
          resp: GetProjectDetailResDTO,
        },
      };
    },
    bb: (req: GetAllProjectsReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getAllProjects', {
          param: {},
          query: {},
        }),
        data: {
          page: req.page,
          pageSize: req.pageSize,
        },
        extraOpts: opts,
        metadata: {
          name: 'getAllProjects',
          method: 'POST',
          path: '/api/getAllProjects',
          req: GetAllProjectsReqDTO,
          resp: GetAllProjectsResDTO,
        },
      };
    },
    bc: (req: null, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getOverviewStats', {
          param: {},
          query: {},
        }),
        data: {},
        extraOpts: opts,
        metadata: {
          name: 'getOverviewStats',
          method: 'POST',
          path: '/api/getOverviewStats',
          req: null as null,
          resp: GetOverviewStatsResDTO,
        },
      };
    },
    bd: (req: GetDailyViewStatsReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getDailyViewStats', {
          param: {},
          query: {},
        }),
        data: {
          pageKey: req.pageKey,
          days: req.days,
        },
        extraOpts: opts,
        metadata: {
          name: 'getDailyViewStats',
          method: 'POST',
          path: '/api/getDailyViewStats',
          req: GetDailyViewStatsReqDTO,
          resp: GetDailyViewStatsResDTO,
        },
      };
    },
    be: (req: null, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/getAllPageViewStats', {
          param: {},
          query: {},
        }),
        data: {},
        extraOpts: opts,
        metadata: {
          name: 'getAllPageViewStats',
          method: 'POST',
          path: '/api/getAllPageViewStats',
          req: null as null,
          resp: GetAllPageViewStatsResDTO,
        },
      };
    },
    bf: (req: RecordPageViewReqDTO, opts?: any) => {
      return {
        method: 'POST' as AllowedRequestMethod,
        url: this._uf('/api/recordPageView', {
          param: {},
          query: {},
        }),
        data: {
          pageKey: req.pageKey,
        },
        extraOpts: opts,
        metadata: {
          name: 'recordPageView',
          method: 'POST',
          path: '/api/recordPageView',
          req: RecordPageViewReqDTO,
          resp: null as null,
        },
      };
    },
  }

  private _uf(url: string, extra: { param?: object; query?: object } = {}): string {
    const { param, query } = extra;
    return urlcat(url, {
      ...param,
      ...query,
    });
  }
}
